import inputDisabled from '../../../../common/algorithms/input-disabled';

const primary = (params) => inputDisabled(params);

export default primary;
